import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  Switch,
} from "react-router-dom";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";
import history from "./misc/history";
import Home from "./pages/Home";
import WhatIs from "./pages/WhatIs";
import ListOfOrganizer from "./pages/ListOfOrganizer";
import Requirement from "./pages/Requirement";
import Regulation from "./pages/Regulation";
import Forum from "./pages/Forum";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ForgotPasswordVerify from "./pages/ForgotPasswordVerify";
import Signup from "./pages/SignUp";
import Profiles from "./pages/Profiles";
import Event from "./pages/Event";
import ConfirmEvent from "./pages/ConfirmEvent";
import VerifyPDF from "./pages/VerifyPDF";
import ProfileOrganizer from "./pages/ProfileOrganizer";
import BlogDetil from "./pages/BlogDetil";
import EventDetil from "./pages/EventDetil";
import Vote from "./pages/Vote";
import Search from "./pages/Search";
import NotFound from "./pages/NotFound";
import StreamYoutube from "./pages/StreamYoutube";
import HomeNew from "./pages/HomeNew";
import NewListOfOrganizer from "./pages/NewListOfOrganizer";
import InfoPsreNew from "./pages/InfoPsreNew";
import RequirementNew from "./pages/RequirementNew";
import CertificationInstitution from "./pages/CertificationInstitution";
import TNC from "./pages/TNC";
import { http } from "./misc/http";
import moment from "moment";
import Privacy from "./pages/Privacy";

const pages = {
  "/": "home",
  "/listpsrenew": "daftar-psre",
  "/lembaga-sertifikat": "lembaga-sertifikat",
  "/listPSrE": "detail-psre",
  "/requirement": "persyaratan",
  "/regulation": "peraturan",
  "/forum": "forum",
  // "/login": "login",
  "/forgotPassword": "lupa-pasword",
  "/forgotPasswordVerify": "verifikasi-lupa-pasword",
  // "/signup": "register-user",
  "/profiles": "profil",
  "/event": "acara",
  "/verifyPDF": "verifikasi-pdf",
  "/organizer/:id": "detail-psre",
  "/blog/:id": "detail-artikel",
  "/event_detil/:id": "detail-acara",
  "/events/join/confirmation/:id/confirm": "join-acara",
  "/events/stream/:id": "live-acara",
  "/vote": "voting",
  "/search": "pencarian",
};

function NewRoute({ component: Component, path, ...rest }) {
  // let _path = path.split("/");
  // _path.splice();
  // if (_path.length > 3) _path = _path.splice(1, _path.length - 1);
  // if (_path.length > 4) _path = _path.splice(2, _path.length - 1);
  // _path = _path.join("/");
  let page = pages[path]
  // console.log("checking _path ", _path);
  // console.log("checking page ", page);
  let params = {
    method: "POST",
    path: `visitor/create`,
    showMessage: false,
    data: {
      page,
      originalPath: path,
      dateTime: moment().format("YYYY-MM-DD hh:mm:ss"),
    },
  };
  http(params);
  return (
    <Route path={path} {...rest} render={(props) => <Component {...props} />} />
  );
}

export default class App extends Component {
  render() {
    return (
      <Router history={history}>
        <ScrollToTop>
          <Switch>
            {/* <NewRoute path="/homenew" exact component={HomeNew} /> */}
            {/* <NewRoute path="/" exact component={Home} /> */}
            <NewRoute path="/" exact component={HomeNew} />
            <NewRoute path="/listpsrenew" component={NewListOfOrganizer} />
            {/* <NewRoute path="/infopsrenew" component={InfoPsreNew} /> */}
            {/* <NewRoute path="/requirementnew" component={RequirementNew} /> */}
            {/* <NewRoute path="/apaitu" component={WhatIs} /> */}
            <NewRoute path="/apaitu" component={InfoPsreNew} />
            <NewRoute
              path="/lembaga-sertifikat"
              component={CertificationInstitution}
            />
            <NewRoute path="/listPSrE/:id" component={NewListOfOrganizer} />
            <NewRoute path="/requirement" component={RequirementNew} />
            {/* <NewRoute path="/requirement" component={Requirement} /> */}
            <NewRoute path="/regulation" component={Regulation} />
            <NewRoute path="/forum" component={Forum} />
            {/* <NewRoute path="/login" component={Login} /> */}
            <NewRoute path="/forgotPassword" component={ForgotPassword} />
            <NewRoute
              path="/forgotPasswordVerify/:token"
              component={ForgotPasswordVerify}
            />
            {/* <NewRoute path="/signup" component={Signup} /> */}
            {/* <NewRoute path="/profiles" component={Profiles} /> */}
            <NewRoute path="/event/:id" component={Event} />
            <NewRoute path="/verifyPDF" component={VerifyPDF} />
            <NewRoute path="/organizer/:id" component={ProfileOrganizer} />
            <NewRoute path="/blog/:id" component={BlogDetil} />
            <NewRoute path="/event_detil/:id" exact component={EventDetil} />
            <NewRoute
              path="/events/join/confirmation/:id/confirm"
              component={ConfirmEvent}
            />
            <NewRoute path="/events/stream/:id" component={StreamYoutube} />
            <NewRoute path="/vote" component={Vote} />
            <NewRoute path="/search" component={Search} />
            <NewRoute path="/tnc" component={TNC} />
            <NewRoute path="/privacy" component={Privacy} />
            <NewRoute path="*" component={NotFound} />
          </Switch>
        </ScrollToTop>
      </Router>
    );
  }
}
